window.openTab=function(event,name){
  const selected=document.getElementById(name);
  if(!selected)return;
  document.querySelectorAll('.tabcontent').forEach(panel=>panel.style.display=panel===selected?'block':'none');
  document.querySelectorAll('.tablinks').forEach(link=>link.classList.toggle('active',link===event.currentTarget));
};
document.addEventListener('DOMContentLoaded',()=>{
  document.getElementById('defaultOpen')?.click();
  const path=location.pathname.replace(/\/$/,'')||'/';
  document.querySelectorAll('header a[href],header-drawer a[href]').forEach(link=>{
    const dest=new URL(link.href,location.href);
    if(dest.origin===location.origin){
      if((dest.pathname.replace(/\/$/,'')||'/')===path)link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    }
  });
});
